import { useState, useEffect } from "react";
import {
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Block as BlockIcon 
} from "@mui/icons-material"
import { useLazyCloseGateQuery } from '@/api/enterance';
import SnackAlert from '@/components/snack-alert';
import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton"
const ActionButtonClose = ({
  channelId,
  onCheckError
}) => {
  const { t } = useTranslation();
  const [openAlertClose, setOpenAlertClose] = useState(false);
  const [showCloseSuccess, setCloseSuccess] = useState(false);
  const [getCloseGate, resultClose] = useLazyCloseGateQuery();
  const resetCloseSuccess = () => {
    setCloseSuccess(false)
  }
  const handleCloseGate = async (id) => {
    try {
      await getCloseGate(id).unwrap()
      setCloseSuccess(true)
    } catch (error) {
      console.error('Ошибка закрытия ворот:', error);
      onCheckError(error?.data?.message || 'Ошибка соединения с сервером (502)')
    }
  }

  useEffect(() => {
    if (resultClose.isSuccess) {
      setOpenAlertClose(true)
    }
  }, [resultClose.isSuccess]);
  
  return (
    <>
      <ActionButton
        color="error"
        startIcon={<BlockIcon />}
        onClick={() => handleCloseGate(channelId)}
      >
        {t('close')}
      </ActionButton>
      <Snackbar
        open={resultClose.data?.message === 'Success!' && showCloseSuccess}
        autoHideDuration={3000}
        onClose={resetCloseSuccess}
      >
        <Alert
          sx={{ width: '100%' }}
          severity="info"
          variant="filled"
          onClose={resetCloseSuccess}
        >
          {t('gate_close')}
        </Alert>
      </Snackbar>
      <SnackAlert
        open={openAlertClose}
        onClose={() => setOpenAlertClose(false)}
        message={
          resultClose.isSuccess
            ? t('the_gate_is_closed')
            : t('something_went_wrong')
        }
        variant="filled"
        severity={resultClose.isSuccess ? 'success' : 'error'}
      />
    </>
  )
}

export default ActionButtonClose;